import { render } from "./SliderArrows.vue?vue&type=template&id=7467125e&scoped=true"
import script from "./SliderArrows.vue?vue&type=script&lang=js"
export * from "./SliderArrows.vue?vue&type=script&lang=js"

import "./SliderArrows.vue?vue&type=style&index=0&id=7467125e&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7467125e"]])

export default __exports__